import React from 'react';
import {IQualityPrice} from '../interfaces/IQualityPrice';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store';

interface IQualityPriceTableProps {
  qualityPriceList: IQualityPrice[];
  changePriceHandler: (event: React.ChangeEvent<HTMLInputElement>, qualityId: number) => void;
}

const QualityPriceTable = ({qualityPriceList, changePriceHandler}: IQualityPriceTableProps) => {
  const {t} = useTranslation();
  const {price} = useSelector((state: RootState) => state.enum);
  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">{t('general.quality')}</th>
            {price?.map((item: string) => (
              <th scope="col" className="text-center">
                {t(`administrator.channelFormats.${item?.toLowerCase()}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {qualityPriceList?.map((qualityPrice, index) => {
            const {prices, quality, name} = qualityPrice;
            return (
              <tr key={index}>
                <td>{name}</td>
                {price?.map((singlePrice) => {
                  return (
                    <td key={singlePrice}>
                      <input
                        type="number"
                        onInput={(e: any) => {
                          e.preventDefault();
                          e.target.value = e.target.value.replaceAll(/[^0-9/.]/g, '');
                        }}
                        onChange={(event) => changePriceHandler(event, quality)}
                        name={singlePrice}
                        value={prices?.[singlePrice] ?? 0}
                        className="form-control"
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default QualityPriceTable;
